import React from 'react';
import UploadIcon from '../../../assets/icons/icon_upload.svg?react'
import PdfFile from '../../../assets/icons/task.svg?react'
import UploadButtonGroup from '../../../components/common/UploadButtonGroup';
import useDropboxUploadHandler from '../../../hooks/useDropboxUploadHandler';
import XButton from '../../../components/common/XButton';
import { reportItemClasses, deleteBtnClasses } from '../../../components/common/listItemClasses';
import { reportSectionClasses } from '../../../components/common/formClasses';

const wrapperClasses = reportSectionClasses;
const headerClasses =
    "flex justify-between items-center text-content p-6 mb-0! " +
    "[&_span]:text-base [&_span]:font-semibold [&_label]:mb-0!";
const uploadLabelClasses = "inline-flex items-center gap-1 text-primary! font-bold";
const fileRowClasses = "flex items-center gap-2";

const TemplateFileUpload = ({ onFileUpload, reportName, uploadButtonText, file, removeFile , accept ='.doc,.docx' }) => {
    
    const { handleDropboxSuccess } = useDropboxUploadHandler({
        accept: accept,
        useValidation: false,
        onFilesReady: async (validFiles) => {
            if (!validFiles.length) return;
            onFileUpload?.({ target: { files: [validFiles[0]] } });
        }
    });

    return (
        <div className={wrapperClasses} >
            <div className={headerClasses}>
                <span>{reportName}</span>
                <UploadButtonGroup
                    accept={accept}
                    multiple={false}
                    onFileSelect={({ file }) => onFileUpload?.({ target: { files: file } })}
                    onDropboxSuccess={handleDropboxSuccess}
                    renderUploadButton={() => (
                        <label className={uploadLabelClasses}>
                            <UploadIcon className="text-primary" />
                            {uploadButtonText}
                        </label>
                    )}
                />
            </div>
            {file?.name && <div className={reportItemClasses}>
                <div className={fileRowClasses}>
                    <PdfFile />
                    {file?.name}
                </div>
                <XButton variant="close" className={deleteBtnClasses} onClick={removeFile} aria-label="Remove file">
                    <i className="fas fa-trash-alt"></i>
                </XButton>
            </div>}
        </div >
    )
}

export default TemplateFileUpload;
